export default function History({data}){
    let size = data.length;
    return(
        <div className="history">
        <div className="total">Total Waves 👋: {data.length}</div>
        <div className="wave wv">
          <div className="hdate ud">Date</div>
          <div className="hmessage ud"> Message</div>
          <div className="haddress ud">Address</div>
        </div>
        {data.map((value,i) => {
          return (
              <div>
            <div className="wave">
              <div className="hdate">{value.timestamp}</div>
              <div className="hmessage"> {value.message}</div>
              <div className="haddress">{value.address}</div>
            </div>
            {i!==size-1&&(
                <div className="chain"><div>⛓</div></div>)}
            </div>
          );
        })}
      </div>
    )
}